import { __awaiter, __generator } from "tslib";
/**
 * Placeholder Adapter
 * Usefull for lazy instantiation. i.e. when you want to create Analytics but you cannot
 * instantiate to correct adapter because not all required configuration is available.
 * This placeholder class can be used. It will queue all IRequest instances and process them
 * once setImplementation is called.
 */
var Placeholder = /** @class */ (function () {
    function Placeholder() {
        var _this = this;
        this.adapterReady = new Promise(function (resolver) { return (_this.adapterReadyResolver = resolver); });
    }
    Placeholder.prototype.setImplementation = function (adapter) {
        if (this.adapter) {
            throw new Error("Can only be set once");
        }
        this.adapter = adapter;
        this.adapterReadyResolver(adapter);
    };
    Placeholder.prototype.record = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var adapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adapterReady];
                    case 1:
                        adapter = _a.sent();
                        return [2 /*return*/, adapter.record(request)];
                }
            });
        });
    };
    Placeholder.prototype.getName = function () {
        return __awaiter(this, void 0, void 0, function () {
            var adapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adapterReady];
                    case 1:
                        adapter = _a.sent();
                        return [2 /*return*/, adapter.getName()];
                }
            });
        });
    };
    return Placeholder;
}());
export default Placeholder;
//# sourceMappingURL=Placeholder.js.map